import React, { useState, useEffect, useRef } from 'react';
import CapSpin from '../../CapSpin';
import CapIcon from '../../CapIcon';
import AiraContainer from '../UtilComponents/AiraContainer';
import { AiraChatBot, AiraChatTitleBar } from '../UtilComponents/Icons';
import CapRow from '../../CapRow';
import CapHeading from '../../CapHeading';
import LocaleHoc from '../../LocaleHoc';
import { compose } from 'redux';
import MultiLineInputBox from '../UtilComponents/MultiLineInpuxBox';
import { IMAGE, VIDEO, clsPrefix, tips } from './constants';
import './_capAiMediaGeneration.scss';
import CapDivider from '../../CapDivider';
import { connect } from 'react-redux';
import { mediaGenerationApi } from './api';
import * as action from './actions';
import { bindActionCreators } from 'redux';
import { makeSelectImageDetail } from './selectors';
import { createStructuredSelector } from 'reselect';
import { fabIconProps, rootClsPrefix } from '../constants';
import { NotificationMethods } from '../UtilComponents/Notification';
import { Tooltip } from '../UtilComponents/Tooltip';

export const CapAiMediaGeneration = ({
    textImageBot,
    textImageBotDesc,
    textImageBotPlaceholder,
    textImageFooter,
    textTipsGenerate,
    textCopy,
    textCopied,
    textDownload,
    textComingSoon,
    textGenerateMore,
    textImageDownload,
    request,
    getAPICallObject,
    imageDetails,
    actions,
    iconPlacement
}) => {
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentTab, setCurrentTab] = useState(0);
    const [imageUrls, setImageUrls] = useState([]);
    const [showImageBox, setShowImageBox] = useState(false);

    const notificationContainerRef = useRef(null);
    useEffect(() => {
        if (Array.isArray(imageDetails?.mediaGen) && imageDetails.mediaGen.length > 0) {
            setImageUrls((prevUrls) => {
                const updatedUrls = [...prevUrls];
                updatedUrls.splice(-4, 4, ...imageDetails.mediaGen);
                return updatedUrls;
            });
            setLoading(false);
            setShowImageBox(true);
            NotificationMethods.success({
                message: textImageDownload,
                getContainer: () => notificationContainerRef?.current || document.body,
            });
        }
    }, [imageDetails]);

    const onHide = () => {
        setQuery('');
        setImageUrls([]);
        setShowImageBox(false)
        setLoading(false);
    }

    const onSubmitHandler = async (isGenerate = false) => {

        if (query.trim()) {
            setLoading(true);
            if (!showImageBox) setShowImageBox(true);
            if (isGenerate) {
                setImageUrls((prevUrls) => [...prevUrls, ...Array(4).fill(null)]);
            } else {
                setImageUrls([...Array(4).fill(null)]);
            }
            actions.mediaGenerationQuery(
                {
                    prompt: query,
                    numberOfImages: 4,
                },
                mediaGenerationApi(request, getAPICallObject)
            );
        }
    };
    return (
        <AiraContainer
            titlePadding="0.95rem"
            popupWidth="32rem"
            Icon={AiraChatBot}
            iconSize="60px"
            iconProps={{
                svgProps: {
                    style: {
                        padding: '16.25px',
                    },
                },
            }}
            title="Aira"
            onHide={onHide}
            titleBarIcon={AiraChatTitleBar}
            popupHeight="100vh"
            popupPlacement={{ type: 'float-br', padding: '0rem' }}
            iconPlacement={iconPlacement}
        >
            <div ref={notificationContainerRef} className={`${clsPrefix}-content`}>
                <CapRow className={`${clsPrefix}-tab-container`}>
                    <CapHeading
                        data-active={currentTab === 0}
                        onClick={() => setCurrentTab(0)}
                        className={`${clsPrefix}-tab`}
                    >
                        {IMAGE}
                    </CapHeading>
                    <Tooltip title={textComingSoon}>
                        <CapHeading
                            data-active={currentTab === 1}
                            className={`${clsPrefix}-tab`}
                        >
                            {VIDEO}

                        </CapHeading>
                    </Tooltip>
                </CapRow>
                <MultiLineInputBox
                    value={query}
                    setValue={setQuery}
                    placeholder={textImageBotPlaceholder}
                    onSubmit={() => onSubmitHandler(false)}
                    loading={loading}
                />

                {imageUrls.length < 1 && !loading && (
                    <>
                        <CapRow className="doc-bot">
                            <CapIcon
                                type="three-star-dark"
                                size="m"
                                className="three-star-icon"
                            />
                            <CapHeading type="h4" className="imageTextBot">
                                {textImageBot}
                            </CapHeading>
                            <CapHeading type="label4" className="doc-bot-desc">
                                {textImageBotDesc}
                            </CapHeading>
                        </CapRow>
                        <CapRow className={`${clsPrefix}-tips-box`}>
                            <CapRow className="tips-box-head">
                                <CapIcon type="info" size="s" />
                                <CapHeading type="h10">{textTipsGenerate}</CapHeading>
                            </CapRow>

                            <ul>
                                {tips.map((tip, index) => (
                                    <li key={index}>
                                        <CapHeading type="label2">
                                            {tip}
                                        </CapHeading>
                                    </li>
                                ))}
                            </ul>
                        </CapRow>
                    </>
                )}

                {showImageBox && (
                    <div className={`${clsPrefix}-image-container ${rootClsPrefix}-no-scrollbar`}>
                        <CapHeading style={{ marginRight: '0.6rem' }}>
                            <CapIcon size="s" type="three-star-dark" className="chat-loader-icon" />
                        </CapHeading>
                        <div className={`${clsPrefix}-image-answer-container`}>
                            {[...Array(Math.max(4, imageUrls.length)).keys()].map((i) => (
                                <ImageContainer key={i} url={imageUrls[i]} loading={loading} textCopied={textCopied} textCopy={textCopy} textDownload={textDownload} />
                            ))}
                            <CapRow
                                className={`${clsPrefix}-generate-more ${loading ? 'loading' : ''}`}
                                onClick={() => !loading && onSubmitHandler(true)}
                                disabled={loading}
                                data-testid="generate-more"
                            >

                                <CapIcon
                                    size="s"
                                    type="gallery-icon"
                                />
                                <CapHeading type="h10">{textGenerateMore}</CapHeading>
                            </CapRow>
                            <CapRow className="rate-icon">
                                <CapIcon
                                    size="s"
                                    type="like"
                                    data-testid="like-button"
                                />
                                <CapIcon
                                    size="s"
                                    type="disLike"
                                    data-testid="dislike-button"
                                />
                            </CapRow>
                        </div>
                    </div>
                )}

                <CapRow className={`${clsPrefix}-text-media-footer`}>
                    <CapDivider style={{ margin: 0 }} />
                    <CapRow className="image-footer">
                        <CapIcon
                            type="info"
                            size="s"
                        />
                        <CapHeading type="label4">
                            {textImageFooter}
                        </CapHeading>
                    </CapRow>
                </CapRow>
            </div>
        </AiraContainer>
    );
};

const ImageContainer = ({ url, loading, textCopy, textCopied, textDownload }) => {
    const [overlay, setOverlay] = useState(false);
    const [showCopied, setShowCopied] = useState(false);


    const handleDragStart = (e) => {
        if (url) {
            e.dataTransfer.setData('text/plain', `<img src=${url} alt='Capillary Image' />`);
        }
    };

    const handleCopy = async () => {
        try {
            if (url) {
                await navigator.clipboard.writeText(url);
                setShowCopied(true);
            }
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div
            onMouseEnter={() => url && setOverlay(true)}
            onMouseLeave={() => setOverlay(false)}
            draggable={!!url}
            onDragStart={handleDragStart}
            className={`image-container ${overlay ? 'image-container-overlay' : ''}`}
        >
            {loading && !url ? (
                <CapSpin spinning data-testid="loading-spinner" />
            ) : (
                url && (
                    <>
                        <img src={url} className="image-container-img" alt="Generated" />
                        {overlay && (
                            <div className="image-container-overlay-content">
                                <Tooltip title={
                                    showCopied ?
                                        <div className={`${clsPrefix}-tooltip-copied-size`}>
                                            <CapIcon type="check-filled" size="s" style={{ marginRight: '4px' }} data-testid="copied" />
                                            <span>{textCopied}</span>
                                        </div>

                                        :
                                        <div className={`${clsPrefix}-tooltip-size`}>
                                            {textCopy}
                                        </div>
                                }>
                                    <CapIcon
                                        type="copy"
                                        size="s"
                                        className="image-container-copy-icon"
                                        onClick={handleCopy}
                                        data-testid="copy-button"
                                    />
                                </Tooltip>
                                <a href={url} download target="_blank" rel="noopener noreferrer">
                                    <Tooltip
                                        title={
                                            <div className="tooltip-size">
                                                {textDownload}
                                            </div>
                                        }
                                    >
                                        <CapIcon
                                            type="download"
                                            size="s"
                                            className="image-container-download-icon"
                                        />
                                    </Tooltip>
                                </a>
                            </div>
                        )}
                    </>
                )
            )}
        </div>
    );
};


const mapStateToProps = createStructuredSelector({
    imageDetails: makeSelectImageDetail(),
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(action, dispatch),
    };
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export default compose(withConnect)(
    LocaleHoc(CapAiMediaGeneration, {
        key: 'CapAskAira.CapAiMediaGeneration',
    }),
);
